<template>
  <yd-dialog
    title="结算通知"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
    append-to-body
  >
    <div class="flex flex-col" style="min-height: 100px">
      <span>{{ initData.company }}</span>
      <span>{{ initData.time }}</span>
      <div>
        <span>{{ initData.remark }}</span>
        <span class="pointer color-main margin-left-10 font-weight" @click="download"
          >点击下载</span
        >
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClose">知道了</el-button>
    </span>
  </yd-dialog>
</template>

<script >
import { ref } from '@vue/composition-api';
import env from '@/config/env';
import exportToExcel, { exportLoading } from '@/views/office/documentManage/hooks/exportToExcel.js';
import { Message } from 'element-ui';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const dialogVisible = ref(false);
  const initData = ref({});
  const init = data => {
    dialogVisible.value = true;
    if (data && data.title) {
      let match = data.title.match(/(.*?公司)(.*)/);
      data.company = match[1];
      data.time = match[2];
    }
    initData.value = data;
  };
  const handleClose = () => {
    dialogVisible.value = false;
  };
  const download = () => {
    if (exportLoading.value) {
      Message.warning('请求中...请稍后');
      return;
    }
    const url = env.importExcelUrl + env.ferryUrl + initData.value.link + '?statementId=' + initData.value.bizId;
    exportToExcel('post', url, {}, '');
  };
  return Object.assign({
    dialogVisible,
    initData,
    handleClose,
    download
  }, {
    init
  });
};
export default __sfc_main;
</script>

<style lang="scss" scoped></style>
